import $ from "jquery";
import "slick-carousel";

// $(".course-slides").slick({
//   // centerMode: true,
//   centerPadding: '70px',
//   slidesToShow: 3,
//   arrows: true,
//   // lazyLoad: onDemand,
//   // responsive: [
//   //   {
//   //     breakpoint: 1200,
//   //     settings: {
//   //       slidesToShow: 3,
//   //     },
//   //   },
//   //   {
//   //     breakpoint: 991,
//   //     settings: {
//   //       slidesToShow: 2,
//   //     },
//   //   },
//   //   {
//   //     breakpoint: 600,
//   //     settings: {
//   //       centerPadding: "40px",
//   //       slidesToShow: 1,
//   //     },
//   //   },
//   // ],
// });

// // Slick slides equal height
// $(".slider").on("setPosition", function () {
//   $(this).find(".slick-slide").height("auto");
//   var slickTrack = $(this).find(".slick-track");
//   var slickTrackHeight = $(slickTrack).height();
//   $(this)
//     .find(".slick-slide")
//     .css("height", slickTrackHeight + "px");
// });

// $(".c-page-slider__slides").slick({
//   // dots: true,
//   infinite: true,
//   speed: 500,
//   fade: true,
//   cssEase: "linear",
// });

// $(".c-blog-slider__posts ul").slick({
//   centerMode: true,
//   centerPadding: "15%",
//   slidesToShow: 2,
//   arrows: true,
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//       },
//     },
//   ],
// });

// jQuery(".c-blog-slider__posts ul").on("setPosition", function () {
//   jQuery(this).find(".slick-slide").height("auto");
//   var slickTrack = jQuery(this).find(".slick-track");
//   var slickTrackHeight = jQuery(slickTrack).height();
//   jQuery(this)
//     .find(".slick-slide")
//     .css("height", slickTrackHeight + "px");
// });

$(document).ready(() => {

  function initPrimarySliders() {
    const sliders = $('.primary-slider');

    sliders.each(function() {
      const slider = $(this);
      slider.slick({
        speed: 300,
        infinite: true,
        centerMode: true,
        centerPadding: '22%',
        slidesToShow: 1,
        responsive: [
          {
            breakpoint: 1240,
            settings: {
              arrows: true,
              dots: false,
              centerMode: true,
              centerPadding: '2.75rem',
              slidesToShow: 1
            }
          }
        ]
      });

      // Attach event listeners using jQuery
      slider.on('afterChange', function(event, slick, currentSlide) {
        handleSlideChange(event, slick);
      });
      slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        handleBeforeChange(event, slick);
      });
      slider.on('init', function(event, slick) {
        handleSlideChange(event, slick);
      });
    });
  }

  function handleSlideChange(event, slick) {
    if (!slick.$slides || !slick.$slides.length) return; // Ensure slides is not null and not empty
    const slides = $(slick.$slides);

    slides.each(function() {
      $(this).removeClass('prevSlide nextSlide');
    });

    const currentIndex = slides.index(slick.$slider.find('.slick-current'));
    if (currentIndex > 0) {
      $(slides[currentIndex - 1]).addClass('prevSlide');
    }
    if (currentIndex < slides.length - 1) {
      $(slides[currentIndex + 1]).addClass('nextSlide');
    }
  }

  function handleBeforeChange(event, slick) {
    if (!slick.$slides || !slick.$slides.length) return; // Ensure slides is not null and not empty
    const slides = $(slick.$slides);

    slides.each(function() {
      $(this).removeClass('prevSlide nextSlide');
    });
  }

  // Initialize primary sliders
  initPrimarySliders();

  // Initialize other sliders
  $('.course-slider, .accommodation-slider, .activity-slider, .wedding-slider').slick({
    speed: 300,
    centerMode: true,
    centerPadding: '22%',
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 1240,
        settings: {
          arrows: true,
          dots: false,
          centerMode: true,
          centerPadding: '2.75rem',
          slidesToShow: 1
        }
      }
    ]
  });

  $('.hole-slider, .secondary-slider, .tertiary-slider').slick({
    speed: 300,
    centerMode: true,
    centerPadding: '15.375rem',
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 1240,
        settings: {
          arrows: true,
          dots: false,
          centerMode: true,
          centerPadding: '2.75rem',
          slidesToShow: 1
        }
      }
    ]
  });

  $('.news-slider, .golf-tips-slider').slick({
    speed: 300,
    centerMode: true,
    centerPadding: '26.25rem',
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          arrows: true,
          dots: false,
          centerMode: true,
          centerPadding: '16rem',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 1240,
        settings: {
          arrows: true,
          dots: false,
          centerMode: true,
          centerPadding: '2.75rem',
          slidesToShow: 1
        }
      }
    ]
  });

  $('.event-slider').slick({
    speed: 300,
    centerMode: true,
    centerPadding: '26.25rem',
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          arrows: true,
          dots: false,
          centerMode: true,
          centerPadding: '26.25rem',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 1240,
        settings: {
          arrows: true,
          dots: false,
          centerMode: true,
          centerPadding: '16rem',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          dots: false,
          centerMode: true,
          centerPadding: '2.75rem',
          slidesToShow: 1
        }
      }
    ]
  });

  $('.full-slider').slick({
    speed: 300,
    arrows: true,
    dots: true,
    appendDots: '#holes-nav',
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 1
  });

  /*
   * The Nines
   *
   */
  // Default to front 9
  function holesDefault() {
    $('.full-slider ~ .slide-nav').find('.nav-front-9').each(function() {
      $(this).addClass('active');
    });
  }
  holesDefault();

  // Activate front 9
  function holesActivateFront9() {
    $('.full-slider ~ .slide-nav').find('.slick-dots').each(function() {
      $(this).addClass('front-9-active');
    });
  }
  holesActivateFront9();

  // Trigger previous slide for full slider
  $('.full-slider ~ .slide-nav').find('.slick-prev').each(function() {
    var button = $(this);
    button.on('click', function() {
      if (0 === $('.slick-dots > li').index($('.slick-dots > li.slick-active'))) {
        $('button.nav-back-9').trigger( 'click' );
      } else if (9 === $('.slick-dots > li').index($('.slick-dots > li.slick-active'))) {
        $('button.nav-front-9').trigger( 'click' );
      }
      $('.full-slider').slick('slickPrev');
    });
  });

  // Trigger next slide for full slider
  $('.full-slider ~ .slide-nav').find('.slick-next').each(function() {
    var button = $(this);
    button.on('click', function() {
      if (8 === $('.slick-dots > li').index($('.slick-dots > li.slick-active'))) {
        $('button.nav-back-9').trigger( 'click' );
      } else if (17 === $('.slick-dots > li').index($('.slick-dots > li.slick-active'))) {
        $('button.nav-front-9').trigger( 'click' );
      }
      $('.full-slider').slick('slickNext');
    });
  });

  // Swap front 9 and back 9 on menu button clicks
  $('.the-nines').find('.nav-button').each(function() {
    var button = $(this);
    button.on('click', function() {
      if (button.hasClass('nav-front-9')) {
        if (! button.hasClass('active')) {
          $('.the-nines').find('.nav-button').each(function() {
            $(this).removeClass('active');
          });
          button.addClass('active');
          $('.full-slider ~ .slide-nav').find('.slick-dots').each(function() {
            $(this).removeClass('back-9-active');
            $(this).addClass('front-9-active');
          });
        }
      } else if (button.hasClass('nav-back-9')) {
        if (! button.hasClass('active')) {
          $('.the-nines').find('.nav-button').each(function() {
            $(this).removeClass('active');
          });
          button.addClass('active');
          $('.full-slider ~ .slide-nav').find('.slick-dots').each(function() {
            $(this).removeClass('front-9-active');
            $(this).addClass('back-9-active');
          });
        }
      }
    });
  });


  let resizeTimeout;

  // Function to initialize or destroy the slick slider based on window width
  function handleGridSlider() {
    const gridSliders = document.querySelectorAll('.grid-slider');
    const windowWidth = window.innerWidth;
    const slickGridSettings = {
      speed: 300,
      arrows: true,
      dots: false,
      centerMode: true,
      centerPadding: '2.813rem',
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '2.813rem',
            slidesToShow: 1
          }
        }
      ]
    };

    gridSliders.forEach(gridSlider => {
      const isSlickInitialized = $(gridSlider).hasClass('slick-initialized');

      if (windowWidth >= 1240) {
        if (isSlickInitialized) {
          $(gridSlider).slick('unslick'); // Destroy slick if initialized
        }
        gridSlider.style.display = 'grid';
      } else {
        if (!isSlickInitialized) {
          $(gridSlider).slick(slickGridSettings); // Initialize slick if not initialized
        }
        gridSlider.style.display = 'grid';
      }
    });
  }

  handleGridSlider();

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout); // Clear the previous timeout
    resizeTimeout = setTimeout(() => {
      handleGridSlider(); // Call the function to reinitialize Slick after a delay
    }, 250);
  });



  // var slickGridSettings = {
  //   arrows: true,
  //   dots: false,
  //   centerMode: true,
  //   centerPadding: '2.813rem',
  //   slidesToShow: 1,
  //   responsive: [
  //     {
  //       breakpoint: 1240,
  //       settings: {
  //         arrows: true,
  //         dots: false,
  //         centerMode: true,
  //         centerPadding: '2.813rem',
  //         slidesToShow: 1
  //       }
  //     }
  //   ]
  // }

  // if ($(window).width() < 1240) {
  //   $('.grid-slider').hide();
  //   $('.grid-slider').slick(slickGridSettings);
  //   $('.grid-slider').show();
  // }

  // // reslick only if it's not slick()
  // $(window).on('resize', function() {
  //   $('.grid-slider').hide();
  //   if ($(window).width() >= 1240) {
  //     setTimeout( function() {
  //       if ($('.grid-slider').hasClass('slick-initialized')) {
  //         $('.grid-slider').slick('unslick');
  //         $('.grid-slider').show();
  //         return;
  //       }
  //     }, 1000 );
  //   } else if ($(window).width() < 1240) {
  //     if (!$('.grid-slider').hasClass('slick-initialized')) {
  //       $('.grid-slider').slick(slickGridSettings);
  //         $('.grid-slider').show();
  //       return;
  //     }
  //   }
  //   $('.grid-slider').show();
  // });




  // Smash Balloon Instagram feed
  setTimeout(function() {
    $('#sbi_images')
      .on('afterChange init', function(event, slick, direction){
        // console.log('afterChange/init', event, slick, slick.$slides);
        // remove all prev/next
        slick.$slides.removeClass('prevSlide').removeClass('nextSlide');

        // find current slide
        for (var i = 0; i < slick.$slides.length; i++) {
          var $slide = $(slick.$slides[i]);
          if ($slide.hasClass('slick-current')) {
            // update DOM siblings
            $slide.prev().addClass('prevSlide');
            $slide.next().addClass('nextSlide');
            break;
          }
        }
      }
    )
    .on('beforeChange', function(event, slick) {
        // optional, but cleaner maybe
        // remove all prev/next
        slick.$slides.removeClass('prevSlide').removeClass('nextSlide');
    })
    .slick({
      speed: 300,
      centerMode: true,
      centerPadding: '15.375rem',
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '2.75rem',
            slidesToShow: 1
          }
        }
      ]
    });
  }, 3000);

  $('.tab-mobile-collapse label').bind('click', function (e) {

    if ( $(this).prev('.tab').is(':checked') ) {
      e.preventDefault();
      if ( $(this).hasClass('expanded') ) {
        $(this).siblings('label').hide();
        $(this).removeClass('expanded');
      } else {
        $(this).siblings('label').show();
        $(this).addClass('expanded');
      }

    } else {
      $(this).siblings('label').hide().removeClass('active').removeClass('expanded');
      $(this).siblings('.tab').attr('aria-expanded', 'false');
      $(this).show().removeClass('expanded').addClass('active');
      $(this).prev('.tab').attr('aria-expanded', 'true');
    }

  });
});

// $(document).ready(() => {
//   $(".c-post__gallery, .c-post__gallery-gutenberg .wp-block-gallery").slick({
//     arrows: false,
//     adaptiveHeight: true,
//   });

//   $(".most_recent_widget").slick();

//   if (wp.customize && wp.customize.selectiveRefresh) {
//     wp.customize.selectiveRefresh.bind(
//       "partial-content-rendered",
//       (placement) => {
//         if (
//           placement.partial.widgetIdParts &&
//           placement.partial.widgetIdParts.idBase ===
//             "theredzone_mst_recent_widget"
//         ) {
//           placement.container.find(".most_recent_widget").slick();
//         }
//       }
//     );
//   }
// });